module.exports = __webpack_public_path__ + "static/media/beverage-drink-hot-svgrepo-com.6fbb5617.svg";